// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"68ccba59","751":"e6c7b28e"}[chunkId] + ".chunk.js";
};